import Checkbox from '@/components/UI/checkbox/Checkbox';
import IncrementStepper from '@/components/reusable/incrementStepper/IncrementStepper';
import { Controller } from 'react-hook-form';
import FilterSwitchItem from '../filterSwitchItem/FilterSwitchItem';
import styles from './InputComponent.module.scss';
import Accordion from '@/components/UI/accordion/Accordion';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
export const InputComponent = ({
  data,
  control,
  queryParams
}) => {
  const {
    type,
    title,
    gtmKey
  } = data;
  const isExpanded = data?.list?.find(item => queryParams[item.query]);
  switch (type) {
    case 'numberInput':
      return <Accordion expanded={!!isExpanded?.title} className={styles['input-component-container']}>
          <Accordion.Title aria-controls={gtmKey}>
            <Box className={styles['accordian-header-section']}>
              <Typography variant="bodyL_Bold">{title}</Typography>
              {!!isExpanded?.title && <div className={styles['active-badge']}></div>}
            </Box>
          </Accordion.Title>
          <Accordion.Content className={styles['accordion-content-section']} filter-seen={gtmKey}>
            {data.list.map(item => {
            return <Controller key={item.query} name={item.query} control={control} defaultValue={!!queryParams[item.query] ? queryParams[item.query] : 0} render={({
              field: {
                value,
                onChange,
                ...props
              }
            }) => {
              return <IncrementStepper format="base" handleChange={(type: string) => {
                if (type === 'increase') {
                  onChange(+value + 1);
                }
                if (type === 'decrease') {
                  onChange(+value - 1);
                }
              }} label={item.query === 'guests' ? 'نفر' : 'اتاق'} value={+value} minimumValue={item.query === 'guests' ? 1 : 0} maximumValue={100} {...props} />;
            }} />;
          })}
          </Accordion.Content>
        </Accordion>;
    case 'checkbox':
      return <Accordion expanded={!!isExpanded?.title} className={styles['input-component-container']}>
          <Accordion.Title aria-controls={gtmKey}>
            <Box className={styles['accordian-header-section']}>
              <Typography variant="bodyL_Bold">{title}</Typography>
              {!!isExpanded?.title && <div className={styles['active-badge']}></div>}
            </Box>
          </Accordion.Title>
          <Accordion.Content className={styles['accordion-content-section']} filter-seen={gtmKey}>
            {data.list.map(item => <Controller key={item.query} name={item.query} control={control} defaultValue={queryParams[item.query]} render={({
            field: {
              value,
              onChange,
              ...props
            }
          }) => <Box>
                    <Checkbox checked={value} label={item.title} onChange={onChange} {...props} />
                  </Box>} />)}
          </Accordion.Content>
        </Accordion>;
    case 'switch':
      return data.list.map(item => <Controller key={item.query} name={item.query} control={control} defaultValue={queryParams[item.query]} render={({
        field: {
          value,
          onChange,
          ...props
        }
      }) => <FilterSwitchItem title={item.title} icon={item.icon} descrpition={item.description} handleChange={onChange} checked={value} {...props} />} />);
    default:
      return <></>;
  }
};